import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteGrupoEconomicoMultiselectComponent } from './cliente-grupo-economico-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteGrupoEconomicoMultiselectComponent
    ],
    exports: [
        ClienteGrupoEconomicoMultiselectComponent
    ]
})
export class ClienteGrupoEconomicoMultiselectModule { }
